const tagManagerSetup = () => {
  if (!import.meta.env.VITE_GOOGLE_TAG_KEY) return;

  const tagManagerScript = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer', '${import.meta.env.VITE_GOOGLE_TAG_KEY}');
  `;

  const tagManagerNoScript = `
    <iframe src="https://www.googletagmanager.com/ns.html?id=${import.meta.env.VITE_GOOGLE_TAG_KEY}"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>
  `;

  const script = document.createElement("script");
  script.innerHTML = tagManagerScript;
  script.async = true;

  document.body.appendChild(script);
  const noscript = document.createElement("noscript");
  noscript.innerHTML = tagManagerNoScript;
  document.body.appendChild(noscript);
};

export default tagManagerSetup;
